import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ScrollText, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CustomerTermsPage = () => {
    const { token } = useAuth();
    const { tenant } = useTenant();
    
    const [terms, setTerms] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTerms();
    }, []);

    const fetchTerms = async () => {
        try {
            const response = await axios.get(`${API}/organization/terms`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTerms(response.data.terms_and_conditions || '');
        } catch (error) {
            console.error('Failed to fetch terms:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <DashboardLayout>
            <div className="space-y-8 animate-fade-in">
                {/* Header */}
                <div>
                    <h1 className="text-3xl font-bold text-slate-900">Teilnahmebedingungen</h1>
                    <p className="text-slate-600 mt-1">
                        Bedingungen für das Empfehlungsprogramm
                    </p>
                </div>

                <Card data-testid="terms-card">
                    <CardHeader>
                        <div className="flex items-center gap-3">
                            <div 
                                className="w-10 h-10 rounded-lg flex items-center justify-center"
                                style={{ backgroundColor: `${tenant?.primary_color}15` }}
                            >
                                <ScrollText size={20} style={{ color: tenant?.primary_color }} />
                            </div>
                            <CardTitle className="text-lg">
                                Teilnahmebedingungen von {tenant?.name}
                            </CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent>
                        {loading ? (
                            <div className="flex items-center justify-center py-12">
                                <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
                            </div>
                        ) : terms ? (
                            <div 
                                className="prose prose-slate max-w-none"
                                data-testid="terms-content"
                            >
                                <div className="whitespace-pre-line text-slate-600 leading-relaxed">
                                    {terms}
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-12">
                                <ScrollText size={48} className="mx-auto text-slate-300 mb-4" />
                                <h3 className="text-lg font-medium text-slate-900 mb-2">
                                    Keine Teilnahmebedingungen hinterlegt
                                </h3>
                                <p className="text-slate-500 max-w-md mx-auto">
                                    Der Administrator hat noch keine Teilnahmebedingungen für dieses 
                                    Empfehlungsprogramm festgelegt.
                                </p>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        </DashboardLayout>
    );
};
